module.exports = __webpack_public_path__ + "static/media/heartEmpty.f617f647.svg";